import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export const Close6 = (props)=>/*#__PURE__*/ _jsx("svg", _object_spread_props(_object_spread({
        width: "6",
        height: "6",
        viewBox: "0 0 12 12",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ _jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.40864 5.99915L11.7045 1.71268C12.0962 1.32088 12.0962 0.685647 11.7045 0.293849C11.3127 -0.0979498 10.6776 -0.0979498 10.2859 0.293849L6 4.59031L1.71414 0.293849L1.71414 0.29385C1.3224 -0.0979496 0.687254 -0.0979496 0.295513 0.293849C-0.0962307 0.685649 -0.0962306 1.32088 0.295513 1.71268L4.59136 5.99915L0.295513 10.2856C-0.0962308 10.6742 -0.0988243 11.3069 0.28972 11.6987C0.291643 11.7006 0.293574 11.7025 0.295513 11.7044H0.295513C0.684057 12.0962 1.31661 12.0988 1.70835 11.7102C1.71029 11.7083 1.71222 11.7064 1.71414 11.7044L6 7.40799L10.2859 11.7044V11.7044C10.6744 12.0962 11.307 12.0988 11.6987 11.7102C11.7006 11.7083 11.7026 11.7064 11.7045 11.7044C12.0962 11.3158 12.0988 10.6832 11.7103 10.2914C11.7084 10.2895 11.7064 10.2875 11.7045 10.2856L7.40864 5.99915Z"
        })
    }));
